import React, { Dispatch } from "react";
import "../styles/_header.scss";
import Navbar from "./Navbar";
interface Props {
  setToggleLanguage: Dispatch<React.SetStateAction<boolean>>;
  toggleLanguage: boolean;
}

const Header: React.FC<Props> = ({ setToggleLanguage, toggleLanguage }) => {
  return (
    <div className="Header" >
      <div className="gradient">
        <div className="languageChange container">
          <span
            onClick={() => setToggleLanguage(true)}
            className={
              toggleLanguage
                ? `englishLanguage activeClass `
                : `englishLanguage `
            }
          >
            EN
          </span>
          <span className="borderRight"></span>
          <span
            onClick={() => setToggleLanguage(false)}
            className={
              toggleLanguage ? `greekLanguage  ` : `greekLanguage activeClass`
            }
          >
            GR
          </span>
        </div>
        <Navbar />
        <div className="littleIcon">
          <img src="spanMouse.png" alt="" className="mouseMidle" />
        </div>
        <div className="littleLogo">
          <img src="smallLogo.png" alt="" />
        </div>
      </div>
        <div className="content-slider">
          <div className="slider">
            <div className="mask">
              <ul>
                <li className="anim1">
                    <img src="gallery1.jpg" className="d-block w-100 vh-100" alt="gallery" />
                </li>
                <li className="anim2">
                <img src="gallery2.jpg" className="d-block w-100 vh-100" alt="gallery" />
                </li>
                <li className="anim3">
                  <img src="gallery7.jpg" className="d-block w-100 vh-100" alt="gallery" />
                </li>
                
              </ul>
            </div>
          </div>
        </div>
    </div>
  );
};

export default Header;
